import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, IconFullScreen, Modal, IconArrowHead } from '../../components';

import css from './ProfilePage.module.css';
import classNames from 'classnames';

const VALID_VIDEO_FORMATS = ['mp4', 'quicktime', 'mov'];
const VALID_PHOTO_FORMATS = ['jpeg', 'jpg', 'tiff', 'png'];

const isPhotoType = file => {
  return !!VALID_PHOTO_FORMATS.filter(f => f.indexOf(file?.format || file?.type) !== -1)?.length;
};
const isVideoType = file => {
  return !!VALID_VIDEO_FORMATS.filter(f => f.indexOf(file?.format || file?.type) !== -1)?.length;
};

const SectionMedia = props => {
  const { media, mediaName, onManageDisableScrolling } = props;

  if (!media?.length) return null;

  const [isOpen, setIsOpen] = useState(false);
  const [mediaPopup, setMediaPopup] = useState(null);

  const onOpenPopup = mediaPopup => {
    setIsOpen(true);
    setMediaPopup(mediaPopup);
  };

  const onClosePopup = () => {
    setIsOpen(false);
    setMediaPopup(null);
  };

  const currentIndex = media.findIndex(m => m.location === mediaPopup?.location);

  const onNextSlide = () => {
    if (currentIndex >= media?.length - 1) {
      setMediaPopup(media?.[0]);
    } else {
      setMediaPopup(media?.[currentIndex + 1]);
    }
  };

  const onPrevSlide = () => {
    if (currentIndex === 0) {
      setMediaPopup(media?.[media?.length - 1]);
    } else {
      setMediaPopup(media?.[currentIndex - 1]);
    }
  };

  return (
    <section className={css.sectionMedia}>
      <Heading as="h3" rootClassName={css.sectionMediaHeading}>
        {mediaName === 'gameHighlights' ? (
          <FormattedMessage id="ProfilePage.photoHeading" />
        ) : mediaName === 'gameHighlightsVideos' ? (
          <FormattedMessage id="ProfilePage.gameHighlightsVideosHeading" />
        ) : mediaName === 'practiceClips' ? (
          <FormattedMessage id="ProfilePage.practiceClipsHeading" />
        ) : mediaName === 'practiceClipsVideos' ? (
          <FormattedMessage id="ProfilePage.practiceClipsVideosHeading" />
        ) : null}
      </Heading>

      <div className={css.media}>
        {media?.length &&
          media.map(media => {
            if (isPhotoType(media)) {
              return (
                <div key={media.key} className={css.mediaHolder} onClick={() => onOpenPopup(media)}>
                  <img src={media.location} alt={media.key} className={css.mediaItem} />
                </div>
              );
            }
            if (isVideoType(media)) {
              return (
                <div key={media.key} className={css.mediaHolder} onClick={() => onOpenPopup(media)}>
                  <video controls className={css.mediaItem}>
                    <source src={media.location} type={`video/mp4`} />
                    Your browser does not support the video tag.
                  </video>
                </div>
              );
            }
          })}
      </div>

      <Modal
        id={`ProfilePage.SectionMedia-${mediaName}`}
        isOpen={isOpen}
        onClose={() => onClosePopup()}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        containerClassName={css.popupContainer}
      >
        <div className={css.popupWrapper}>
          <span
            className={classNames(css.popupArrow, css.popupArrowPrev)}
            onClick={() => onPrevSlide()}
          >
            <IconArrowHead direction="left" size="big" />
          </span>

          {isPhotoType(mediaPopup) && (
            <img className={css.popupContent} src={mediaPopup.location} alt="ProfilePage image" />
          )}
          {isVideoType(mediaPopup) && (
            <video controls className={css.popupContent} key={mediaPopup.location}>
              <source src={mediaPopup.location} type={`video/mp4`} />
              Your browser does not support the video tag.
            </video>
          )}

          <span
            className={classNames(css.popupArrow, css.popupArrowNext)}
            onClick={() => onNextSlide()}
          >
            <IconArrowHead direction="right" size="big" />
          </span>
        </div>
      </Modal>
    </section>
  );
};

export default SectionMedia;
